import {
  TENANT_VIEW,
  PROJECT_VIEW,
  JOB_VIEW,
  ARTIFACT_VIEW,
  WORKER_VIEW,
  API_KEY_VIEW,
  MEMBER_VIEW,
  USAGE_VIEW,
  AUDIT_VIEW,
  BILLING_VIEW,
  TENANT_MANAGE,
  AI_TECHNICAL_ARTIST_USE,
  RIGGING_JOB_VIEW,
} from '../auth/permissions';

export const consoleNavItems = [
  { label: 'Overview', path: '/console', permission: TENANT_VIEW, end: true },
  { label: 'Character Studio', path: '/studio', permission: null },
  { label: 'Character Stage', path: '/character-stage', permission: null },
  { label: 'Projects', path: '/console/projects', permission: PROJECT_VIEW },
  { label: 'AI Technical Artist', path: '/console/ai', permission: AI_TECHNICAL_ARTIST_USE },
  { label: 'Bake Jobs', path: '/console/jobs', permission: JOB_VIEW },
  {
    label: 'Rigging Jobs',
    path: '/console/rigging-jobs',
    permission: RIGGING_JOB_VIEW,
    feature: 'ai_rigging',
  },
  { label: 'Artifacts', path: '/console/artifacts', permission: ARTIFACT_VIEW },
  { label: 'Workers', path: '/console/workers', permission: WORKER_VIEW },
  { label: 'Partner API Keys', path: '/console/api-keys', permission: API_KEY_VIEW },
  { label: 'Usage', path: '/console/usage', permission: USAGE_VIEW },
  { label: 'Account & Billing', path: '/console/account/billing', permission: BILLING_VIEW },
  { label: 'Activity', path: '/console/activity', permission: AUDIT_VIEW },
  { label: 'Team', path: '/console/team', permission: MEMBER_VIEW },
  { label: 'Roles & Permissions', path: '/console/team/roles', permission: MEMBER_VIEW },
  { label: 'Partner Settings', path: '/console/partner', permission: TENANT_MANAGE },
  { label: 'Account', path: '/console/account', permission: null },
];

/**
 * @param {Array} items
 * @param {(perm: string) => boolean} hasTenantPermission
 * @param {{ aiRiggingEnabled?: boolean }} [options]
 */
export function filterNavByPermission(items, hasTenantPermission, options = {}) {
  return items.filter((item) => {
    if (item.permission && !hasTenantPermission(item.permission)) return false;
    if (item.feature === 'ai_rigging' && !options.aiRiggingEnabled) return false;
    return true;
  });
}

export default consoleNavItems;
